import { render, staticRenderFns } from "./ImportantItems.vue?vue&type=template&id=5f6d69cd&scoped=true&"
import script from "./ImportantItems.vue?vue&type=script&lang=js&"
export * from "./ImportantItems.vue?vue&type=script&lang=js&"
import style0 from "./ImportantItems.vue?vue&type=style&index=0&lang=sass&"
import style1 from "./ImportantItems.vue?vue&type=style&index=1&id=5f6d69cd&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6d69cd",
  null
  
)

export default component.exports